var HtmlUtil = /** @class */ (function () {
    function HtmlUtil() {
    }
    HtmlUtil.toggleClass = function (element, className, forceValue) {
        if (forceValue === void 0) { forceValue = null; }
        if (!element) {
            return;
        }
        var original = element.className.split(' ');
        if (forceValue == null) {
            forceValue = original.indexOf(className) === -1;
        }
        if (forceValue) {
            if (original.indexOf(className) === -1) {
                original.push(className);
            }
        }
        else {
            original = original.filter(function (name) {
                return name !== className;
            });
        }
        element.className = original.join(' ');
    };
    HtmlUtil.transform = function (element, transform) {
        element.style.transform = transform;
        element.style.webkitTransform = transform;
    };
    return HtmlUtil;
}());
export { HtmlUtil };
